import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { UserData } from 'src/app/data/user.data';
import { environment } from 'src/environments/environment';
import { UserImageData } from 'src/app/data/user/user-image.data';
import { UserExcelData } from '../data/user/user-excel.data';
import { Subscription } from 'rxjs';
import { FileUtil } from 'src/app/tools/file.utils';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class UserService implements OnDestroy {

  public events:EventEmitter<string> = new EventEmitter<string>();

  /**
   * Constructor
   */
  constructor(
    private userData:UserData,
    private http:HttpClient,
    private translate:TranslateService
  ) {
    window.addEventListener("message", this.receiveMessage, false);
  }

  ngOnDestroy() {
    window.removeEventListener("message", this.receiveMessage, false);
  }

  receiveMessage = (event) => {
      if(!event.data) return;
      if(event.data.type !== "USER_EVENT") return;

      if(event.data.action === "LOGIN") {
        this.loadUserDatas().then(()=>{
          this.events.emit("USERDATA_UPDATE");
        });
      } else if(event.data.action === "LOGIN_CANCEL") {
          this.events.emit("LOGIN_CANCEL");
      }

      //console.log(event.data);
  }

  invokeLogin():Promise<void> {
    return new Promise((resolve, reject) => {
      let _waitForLogin = this.events.subscribe((evt)=>{
        if(evt == "USERDATA_UPDATE"){
          _waitForLogin.unsubscribe();
          resolve();
        } else if(evt == "LOGIN_CANCEL"){
          _waitForLogin.unsubscribe();
          reject("LOGIN_CANCEL");
        }
      });
      window.postMessage({
        type:"USER_EVENT",
        action:"ASK_LOGIN"
      },window.location.origin);
    });
  }

  uploadImage(image:File):Promise<UserImageData> {
    return new Promise((resolve, reject) => {

      FileUtil.fileToBlob(image).then((imageBlob)=>{
        let _formData = new FormData();
        _formData.append("type", "1");
        _formData.append("file", imageBlob, image.name);
        this.http.post(environment.API_BASE + environment.API_SERVICES.media, _formData).subscribe((response: any) => {
          if(response.error === false) {
            let _image:UserImageData = new UserImageData(response.media.id, response.media.name, environment.USER_IMAGES_FOLDER + response.media.src,null,response.media.srcSize,environment.USER_IMAGES_FOLDER +response.media.thumbSrc);
            resolve(_image);
          } else if(response.error === true) {
            reject(response.errorMessages[0]);
          } else {
            reject("cfg_imageImportFail1");
          }
        }, (err) => {
          console.log(err);
          reject(false);
        });
      });

    });
  }


  uploadCsv(csvFile:File):Promise<UserExcelData> {
    return new Promise((resolve, reject) => {

      FileUtil.fileToBlob(csvFile).then((csvBlob)=>{
        let _formData = new FormData();
        _formData.append("type", "3");
        _formData.append("file", csvBlob, csvFile.name);
        this.http.post(environment.API_BASE + environment.API_SERVICES.media, _formData).subscribe((response: any) => {
          if(response.error === false) {
            let _excelData:UserExcelData = new UserExcelData(response.media.id, response.media.name, environment.USER_CSV_FOLDER + response.media.src);
            resolve(_excelData);
          } else if(response.error === true) {
            reject(response.errorMessages[0]);
          } else {
            reject("cfg_imageImportFail1");
          }
        }, (err) => {
          console.log(err);
          reject(false);
        });
      });

    });
  }


  uploadFont(fontFile:File):Promise<any> {
    return new Promise((resolve, reject) => {

      FileUtil.fileToBlob(fontFile).then((fontBlob)=>{
        let _formData = new FormData();
        _formData.append("type", "2");
        _formData.append("file", fontBlob, fontFile.name);
        this.http.post(environment.API_BASE + environment.API_SERVICES.media, _formData).subscribe((response: any) => {
          if(response.error === false) {
            resolve(response.media);
          } else if(response.error === true) {
            reject(response.errorMessages[0]);
          } else {
            reject("cfg_imageImportFail1");
          }
        }, (err) => {
          console.log(err);
          reject(false);
        });
      });

    });
  }

  loadUserDatas() {
    return new Promise((resolve, reject) => {

      this.http.get(environment.API_BASE + environment.API_SERVICES.user).subscribe((response: any) => {
        if(response.error === false) {
          response.user.medias.map((ua:any)=>{

            if(ua.type===1){
              let _image:UserImageData = new UserImageData(ua.id, ua.name, environment.USER_IMAGES_FOLDER + ua.src,null,ua.srcSize,environment.USER_IMAGES_FOLDER +ua.thumbSrc);
              this.addImage(_image);
            }else if(ua.type===3){
              let _excel:UserExcelData = new UserExcelData(ua.id, ua.name, environment.USER_CSV_FOLDER + ua.src);
              this.addExcel(_excel);
            }
          });
          let _noFolderLabel = this.translate.instant('cfg_noDirectory');
          response.user.projects.map((project:any)=>{
            return project.folder;
          }).filter((item, pos, self)=>{
            if(item == "") return false;
            if(item == _noFolderLabel) return false;
            return self.indexOf(item) == pos;
          }).sort((a:string,b:string)=>{
            return (a.toLocaleLowerCase() > b.toLocaleLowerCase()) ? 1 : -1;
          }).map((folder:string)=>{
            this.addFolder(folder);
          });
          this.userData.id = response.user.id;
          resolve(true);
        } else if(response.error === true) {
          reject(response.errorMessages);
        } else {
          reject("Unknown_error");
        }
      }, (err) => {
        console.log(err);
        reject(false);
      });


    });
  }

  ping() {
    // Session should not die !
  }


  /**
   * Add folder
   */
  public addFolder(folder:string):Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.userData.folders.push(folder);
      resolve(true);
    });
  }

  /**
   * Add excel
   */
  public addExcel(excel:UserExcelData):Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.userData.excels.push(excel);
      resolve(true);
    });
  }

  /**
   * Add image
   */
  public addImage(image:UserImageData):Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.userData.images.push(image);
      resolve(true);
    });
  }

  /**
   * Load project
   */
  public loadProject(projectUrl): Promise<any> {

    return new Promise((resolve, reject) => {
      this.http.get(environment.PROJECT_FOLDER + projectUrl+"?noCache="+Math.random()).subscribe((response: any) => {
        resolve(response);
      }, (err) => {
        console.log(err);
        reject(false);
      });
    });
  }

  public saveProject(id:number, name:string, folder:string, designFamilyId:number, sheetId:number, productFamilyId:number, data:any):Promise<any> {
    return new Promise((resolve, reject) => {

        let _formData = new FormData();
        if(id > 0) _formData.append("id", id.toString());
        _formData.append("name", name);
        _formData.append("folder", folder);
        _formData.append("designFamilyId", designFamilyId.toString());
        _formData.append("sheetId", sheetId.toString());
        _formData.append("productFamilyId", productFamilyId.toString());
        _formData.append("data", JSON.stringify(data));

        this.http.post(environment.API_BASE + environment.API_SERVICES.project, _formData).subscribe((response: any) => {
          if(response.error === false) {
            resolve(response.project);
          } else if(response.error === true) {
            reject(response.errorMessages[0]);
          } else {
            reject("cfg_savePanel_saveError");
          }
        }, (err) => {
          let errorMsg = 'cfg_savePanel_saveError'
          if(err.error) {
            if (err.error.detail) {
              errorMsg = err.error.detail;
            }
          } else if(err.message) {
            errorMsg = err.message;
          }
          reject(errorMsg);
        });

    });
  }
}
